import type { AppDispatch } from "@/store"
import { limparCarrinho } from "@/store/carrinho-slice"
import { atualizarTotemPedidos, resetarTotemPedidos, type TotemPedidosState } from "@/store/totem-pedidos-slice"
import { comTransicao } from "@/lib/transicao-view"

export type MudancaTotem = Partial<TotemPedidosState> & {
    currentView: TotemPedidosState["currentView"]
}

export function irVista(dispatch: AppDispatch, mudanca: MudancaTotem): void {
    comTransicao(() => dispatch(atualizarTotemPedidos(mudanca)))
}

export function reiniciarAtendimento(dispatch: AppDispatch): void {
    dispatch(limparCarrinho())

    comTransicao(() => dispatch(resetarTotemPedidos()))
}
